import axios from 'axios';
import API_BASE_URL from './config/api';

let currentUrl = API_BASE_URL;

const api = axios.create({
	baseURL: `http://${currentUrl}:${process.env.REACT_APP_API_PORT}`,
});

export const requestData = async (endpoint) => {
	const { data } = await api.get(endpoint);
	return data;
};

export const requestUnitDetails = async (unit_name) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/unidades/?search=${unit_name}`,
		);
		return data;
	} catch (error) {
		console.log(error);
		return {
			error: 'erro ao recuperar os dados da unidade.',
		};
	}
};

/* REQUEST DE INPUTS */
export const requestInputsChoices = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/incidentes/choices/`);
		return data;
	} catch (error) {
		console.log(error);
		return {
			error: 'erro ao recuperar os dados de inputs e listas.',
		};
	}
};

/* REQUEST DE SETORES POR UNIDADE */
export const requestSetores = async (unidade_id) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/unidades/${unidade_id}/setores/`,
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* REQUEST DE INVESTIGADORES POR PROTOCOLO */
export const requestNoteInfo = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/notificacoes/${protocolo}/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

/* REQUEST PARA CRIAÇÃO DE NOVAS NOTIFICAÇÕES */
export const requestNewNoteCreate = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/notificacoes/`,
			body,
		);

		return data;
	} catch (error) {
		console.error('Erro ao criar notificação:', error);
		return {
			error: error.response.data,
		};
	}
};

/* REQUEST DE SUBCLASSIFICACOES */
export const requestNeverevents = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/choices/?fields=sub_classificacao`,

			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* REQUEST PARA CRIAR CLASSIFICAÇÃO */
export const requestNewClassCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/classificacoes/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* REQUEST DE CLASSIFICAÇÃO POR PROTOCOLO */
export const requestClassificacaoByProtocolo = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/classificacoes/${protocolo}/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return { error: error };
	}
};

/* REQUEST DE INVESTIGADORES POR PROTOCOLO */
export const requestInvestigators = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/protocolo/${protocolo}/investigadores/disponiveis/`,
			{
				headers: { Authorization: `Token ${token}` },
			},
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};
